<template>
<div>
		<div  id="mascus_single_product">
			<div class="container pt-5 pt-md-8">


				<div class="row g-md-8">
					<div class="col-12 col-md-6" id="vue-product-gallery">
						<product-gallery :images="product.attachments.attachment" type="mascus" :key="product.id" />
					</div>

					<div class="col-12 col-md-6">
						<div class="row">
							<div class="col">

								<h1 class="entry-title mb-4">{{ product.name }}</h1>
								<!-- <h3 class="mb-4 text-primary">
									{{ getProductAttribute(product, 'priceoriginal') }} SEK
								</h3> -->
								<h3 class="mb-4 text-primary">
									{{ getProductAttribute(product, 'priceoriginal') }} SEK <span style="font-size: 0.75rem;">exkl.moms</span>
								</h3>
								<div class="mb-4">År: {{ getProductAttribute(product, 'yearofmanufacture') }}</div>
								<div class="mb-4">Uppställningsplats: {{ getProductAttribute(product, 'location') }}</div>

								<hr />

								<div class="d-grid gap-2 mt-4">
									<a href="#mascus_contact_form" class="btn btn-lg btn-primary" type="button">Gör en intresseanmälan</a>
								</div>

							</div>
						</div>
					</div>

				</div>
			</div>

			<div class="container my-5 my-md-8">
				<hr />
			</div>

			<div class="container px-0 px-md-3 pb-5 pb-md-8">
				<div class="accordion" id="accordions">

					<div class="accordion-item">
						<h2 class="accordion-header" id="heading1">
							<button class="accordion-button"
									type="button"
									data-bs-toggle="collapse"
									data-bs-target="#collapse1"
									aria-expanded="true"
									aria-controls="collapse1"
							>
								Basinformation
							</button>
						</h2>
						<div id="collapse1"
							 class="accordion-collapse collapse show"
							 aria-labelledby="heading1"
							 data-bs-parent="#accordions"
						>
							<div class="accordion-body">

								<div class="attributes-table">
									<div class="attribute">
										<div class="row">
											<div class="col fw-bold">Produktgrupp</div>
											<div class="col">VÄRDE SAKNAS</div>
										</div>
									</div>
									<div class="attribute">
										<div class="row">
											<div class="col fw-bold">Märke</div>
											<div class="col">{{ getProductAttribute(product, 'brand') }}</div>
										</div>
									</div>
									<div class="attribute">
										<div class="row">
											<div class="col fw-bold">Tillverkningsår</div>
											<div class="col">{{ getProductAttribute(product, 'yearofmanufacture') }}</div>
										</div>
									</div>
									<div class="attribute">
										<div class="row">
											<div class="col fw-bold">Uppställningsplats</div>
											<div class="col">{{ getProductAttribute(product, 'location') }}</div>
										</div>
									</div>
									<div class="attribute">
										<div class="row">
											<div class="col fw-bold">Land</div>
											<div class="col">{{ getProductAttribute(product, 'countryconverted') }}</div>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>

					<div class="accordion-item">
						<h2 class="accordion-header" id="heading2">
							<button class="accordion-button collapsed"
									type="button"
									data-bs-toggle="collapse"
									data-bs-target="#collapse2"
									aria-expanded="false"
									aria-controls="collapse2"
							>
								Pris
							</button>
						</h2>
						<div id="collapse2"
							 class="accordion-collapse collapse"
							 aria-labelledby="heading2"
							 data-bs-parent="#accordions"
						>
							<div class="accordion-body">
								<div class="attributes-table">
									<div class="attribute">
										<div class="row">
											<div class="col fw-bold">Pris exklusive moms</div>
											<div class="col">{{ getProductAttribute(product, 'priceoriginal') }} SEK</div>
										</div>
									</div>
									<div class="attribute">
										<div class="row">
											<div class="col fw-bold">moms (25%)</div>
											<div class="col">{{ vat(getProductAttribute(product, 'priceoriginal'), getProductAttribute(product, 'vatrate')) }} SEK</div>
										</div>
									</div>
									<div class="attribute">
										<div class="row">
											<div class="col fw-bold">Pris inklusive moms</div>
											<div class="col">{{ priceIncVat(getProductAttribute(product, 'priceoriginal'), getProductAttribute(product, 'vatrate')) }} SEK</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="accordion-item">
						<h2 class="accordion-header" id="heading3">
							<button class="accordion-button collapsed"
									type="button"
									data-bs-toggle="collapse"
									data-bs-target="#collapse3"
									aria-expanded="false"
									aria-controls="collapse3"
							>
								Detaljer
							</button>
						</h2>
						<div id="collapse3"
							 class="accordion-collapse collapse"
							 aria-labelledby="heading3"
							 data-bs-parent="#accordions"
						>
							<div class="accordion-body">
								<div class="attributes-table">
									<div class="attribute" v-for="attribute in miscAttributes">
										<div class="row">
											<div class="col fw-bold">{{ attribute.text }}</div>
											<div class="col">{{ attribute.value }} <span v-if="attribute.suffix">{{ attribute.suffix }}</span></div>
										</div>
									</div>
									<div class="attribute" v-if="product.accessories && product.accessories.accessory">
										<div class="row">
											<div class="col fw-bold">Entreprenad tillbehör</div>
											<div class="col">
												<p v-for="attribute in product.accessories.accessory"> {{ attribute }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

		</div>
</div>
</template>

<script>
import { miscAttributesMap } from "./map"

import mixins from './mixins'

import productGallery from '../product-gallery'
import contactForm from './contact-form'

export default {

	mixins: [mixins],

	components: {
		productGallery,
		contactForm
	},

	props: {
		product: {
			required: true
		},
		propertyDefinitions: {
			required: true
		},
		filteredProducts: {
			required: true
		}
	},

	data() {
		return {
			contacts: [],
		}
	},

	mounted () {
		this.emitter.emit('setRelatedProducts', this.randomProducts)
		this.pupulateSellers()
		$('#mascus_contact_form').addClass('show');
	},

	unmounted () {
		this.emitter.emit('setRelatedProducts', [])
		$('#mascus_contact_form').removeClass('show');
	},

	updated () {
		this.emitter.emit('setRelatedProducts', this.randomProducts)
		this.pupulateSellers()
	},

	computed: {
		miscAttributes () {
			const attributes = []
			this.product.property.forEach(property => {
				const definition = this.propertyDefinitions.find(d => d._name === property._name)

				if (miscAttributesMap.indexOf(property._name) !== -1 && definition) {
					attributes.push({
						text: definition._displayname,
						value: property['#text'],
						suffix: definition._displayunit
					})
				}
			})

			return attributes
		},

		randomProducts () {
			const numSlice = this.filteredProducts.length < 4 ? this.filteredProducts.length : 4

			return this.filteredProducts.filter(p => p.id !== this.product.id).slice(0, numSlice)
		}
	},

	methods: {
		vat (price, vatrate) {
			return price * (vatrate / 100)
		},

		priceIncVat(priceExVat, vatrate) {
			return priceExVat * ((vatrate / 100) + 1)
		},

		pupulateSellers() {

			$('.mascus_sellers select').find('option').remove()

			this.product.sellers.forEach(s => {
				$('.mascus_sellers select').append($('<option>', {
					value: s.seller.email,
					text: s.seller.name
				}));
			})
		}
	}
}
</script>
